import { render, staticRenderFns } from "./epb-select-dropdown.component.vue?vue&type=template&id=67ef809a&scoped=true"
import script from "./epb-select-dropdown.component.vue?vue&type=script&lang=ts"
export * from "./epb-select-dropdown.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-select-dropdown.component.vue?vue&type=style&index=0&id=67ef809a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef809a",
  null
  
)

export default component.exports